export default {
    flat: "Квартира",
    parking: "Парковка",
    apartment: "Апартаменты",
    commercial: "Ком. помещение",
    warehouse: "Кладовка",
}